import React from 'react';
import {Link} from 'react-router-dom';
import {Label, Menu, Icon} from 'semantic-ui-react';
import {SS_KEY} from '../../constants';

import './index.css';

export class ChatedDrawer extends React.Component {
	state = {activeItem: 'dashboard'}

	handleItemClick = (e, {name}) => this.setState({activeItem: name})

	getActiveItem(pathname) {
		switch (pathname) {
			// checkouts
			case '/dashboard/checkouts':
				return 'dashboard-checkouts';
			// emails
			case '/dashboard/emails/statistics':
				return 'dashboard-emails-statistics';
			case '/dashboard/emails':
				return 'dashboard-emails';
			case '/dashboard/emails/activity':
				return 'dashboard-emails-activity';
			case '/dashboard/emails/settings':
			case '/dashboard/emails/settings/general':
			case '/dashboard/emails/settings/customization':
				return 'dashboard-emails-settings';
			// payment
			case '/dashboard/payments':
				return 'dashboard-payments';
			// features
			case '/dashboard/whitelabel':
				return 'dashboard-whitelabel';
			case '/dashboard/email-plus':
				return 'dashboard-email-plus';
			case '/dashboard/features/api':
				return 'dashboard-features-api';
			case '/dashboard/features/more':
				return 'dashboard-features-more';
			default:
				return 'dashboard';
		}
	}

	renderMenu(title) {
		return (<Menu.Header style={{margin: '16px 0px 2px 10px'}}>{title}</Menu.Header>);
	}

	renderAbandonedCheckoutsMenuItem(activeItem) {
		const userAppSlug = window.sessionStorage.getItem(SS_KEY.APP_SLUG);
		if (userAppSlug === 'bigcommerce') {
			return null;
		}
		return (
			<Menu.Item name='dashboard-emails-checkouts' active={ activeItem === 'dashboard-checkouts' } onClick={this.handleItemClick}
				as={ Link } to='/dashboard/checkouts'
			>
				<Icon name='shop' />
				Abandoned Checkouts
			</Menu.Item>
		);
	}

	render () {
		const activeItem = this.getActiveItem(this.props.location.pathname);

		return (
			<div className="drawer-container">
				<Menu fluid secondary vertical>
					{ this.renderAbandonedCheckoutsMenuItem(activeItem) }
					{ this.renderMenu('Email Notifications') }
					<Menu.Item name='dashboard-emails-statistics' active={ activeItem === 'dashboard-emails-statistics' } onClick={this.handleItemClick}
						as={ Link } to='/dashboard/emails/statistics'
					>
						<Icon name='line chart' />
						Statistics
					</Menu.Item>
					<Menu.Item name='dashboard-emails' active={ activeItem === 'dashboard-emails' } onClick={this.handleItemClick}
						as={ Link } to='/dashboard/emails'
					>
						<Icon name='mail' />
						Emails
					</Menu.Item>
					<Menu.Item name='dashboard-emails-activity' active={ activeItem === 'dashboard-emails-activity' } onClick={this.handleItemClick}
						as={ Link } to='/dashboard/emails/activity'
					>
						<Icon name='exchange' />
						User Activity
					</Menu.Item>
					<Menu.Item name='dashboard-emails-settings' active={ activeItem === 'dashboard-emails-settings' } onClick={this.handleItemClick}
						as={ Link } to='/dashboard/emails/settings/general'
					>
						<Icon name='setting' />
						Settings
					</Menu.Item>
					<Menu.Item name='dashboard-whitelabel' active={ activeItem === 'dashboard-whitelabel' } onClick={this.handleItemClick}
						as={ Link } to='/dashboard/whitelabel'
					>
						<Icon name='world' />
						Domain Verification
					</Menu.Item>
					{/* { this.renderMenu('Account') }
					<Menu.Item name='dashboard-payments' active={ activeItem === 'dashboard-payments' } onClick={this.handleItemClick}
						as={ Link } to='/dashboard/payments'
					>
						<Icon name='money'/>
						Payments
					</Menu.Item> */}
					{ this.renderMenu('New Features') }
					{/* <Menu.Item name='dashboard-email-plus' active={ activeItem === 'dashboard-email-plus' } onClick={this.handleItemClick}
						as={ Link } to='/dashboard/email-plus'
					>
						<Icon.Group style={{paddingLeft: '18px', marginRight: '10px'}}>
							<Icon name='mail outline' />
							<Icon corner name='add' />
						</Icon.Group>
						Email+
					</Menu.Item> */}
					<Menu.Item onClick={() => {window.open('https://apps.shopify.com/free-email-popups-by-chated-io', '_blank');}}
						as={ Link } to='/dashboard/whitelabel'
					>
						<Icon name='lightning' />
						Email Collector
					</Menu.Item>
					{/*
					<Menu.Item onClick={() => {window.open('https://app.1event.io/?utm_source=chated&utm_medium=abandoned-cart', '_blank');}}
						as={ Link } to='/dashboard/whitelabel'
					>
						<Icon name='lightning' />
						Flash Sales Page
					</Menu.Item>
					<Menu.Item name='dashboard-features-api' active={ activeItem === 'dashboard-features-api' } onClick={this.handleItemClick}
						as={ Link } to='/dashboard/features/api'
					>
						<Icon name='code' />
						API
					</Menu.Item> */}
					<Menu.Item name='dashboard-features-more' active={ activeItem === 'dashboard-features-more' } onClick={this.handleItemClick}
						as={ Link } to='/dashboard/features/more'
					>
						<Icon name='ellipsis horizontal' />
						More
					</Menu.Item>
				</Menu>
			</div>
		);
	}
}

export default ChatedDrawer;



// WEBPACK FOOTER //
// ./src/components/chated-drawer/index.js